import { Modal, ModalOverlay, ModalBody, ModalContent, useDisclosure, Flex, Icon, Box } from "@chakra-ui/react";
import LaunchdeckCloseButton from './LaunchdeckCloseButton';


export default function LaunchdeckModal({
  children,
  title,
  handleCloseModal,
  showModal,
  isWarning,
  maxW,
  noCancelOption,
  bannerBg,
  bgGradient
}) {

  const { isOpen, onClose } = useDisclosure();

  if (showModal) {
    return (
      <Modal
        isOpen={showModal || isOpen}
        onClose={onClose}
        preserveScrollBarGap={true}
        returnFocusOnClose={false}
        maxHeight='80vh'
        closeOnOverlayClick={false}
        isCentered={true}
        position='fixed'
      >
        <ModalOverlay />
        <ModalContent rounded='0.5em' mx={'5%'} w='100%' maxW={maxW || ['90%', '700px']} >
          <ModalBody p='0em'>
            <Flex w='100%' justify='space-between' align='center' borderBottom={title ? '1px solid' : 'none'}
              bg={bannerBg || 'brandDark.500'}
              bgGradient={bgGradient && bgGradient}
              roundedTop='0.5em'
              color='white'
              minH={!!noCancelOption && !title && '2.5em'}
              borderBottomColor='gray.300' p='0.4em 1em 0.4em 1.7em'>
              <Flex justify='flex-start' align='center' w='100%'>
                {isWarning && <Icon name="warning" boxSize="1em" color="red.400" mr='1em' />}<Box as='span' fontSize='0.9em' lineHeight='22px' fontWeight='500' w='100%'> {title} </Box>
              </Flex>
              {noCancelOption ? null : <LaunchdeckCloseButton color={bannerBg && 'white'} handleCloseModal={handleCloseModal} />}
            </Flex>
            <Flex direction='column' justify='space-between'>

              <Flex direction='column' w='100%' align='center'>
                {children}
              </Flex>
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    )
  } else return null;
}
